if (!customElements.get('product-inventory')) {
  const __lang = (document.documentElement.lang || '').toLowerCase();
  const __T_DE = {
    on: 'Lieferung am', fastest: 'oder schnellste Lieferung am', free: 'GRATIS',
    uk_free: 'KOSTENLOSE UK-Lieferung', uk_paid: 'UK-Lieferung', intl: 'internationale Lieferung an der Kasse',
    av_very_low: 'Sehr geringer Lagerbestand', av_low: 'Geringer Lagerbestand',
    av_normal: 'Auf Lager (jetzt bestellen für früheren Versand)', av_backordered: 'Auf Bestellung verfügbar',
    av_none: 'Derzeit nicht verfügbar'
  };
  const __T_FR = {
    on: 'Livraison le', fastest: 'ou livraison la plus rapide le', free: 'GRATUIT',
    uk_free: 'Livraison GRATUITE au Royaume-Uni', uk_paid: 'Livraison au Royaume-Uni', intl: 'livraison internationale au paiement',
    av_very_low: 'Stock très faible', av_low: 'Stock faible',
    av_normal: 'En stock (commandez maintenant pour une expédition plus rapide)', av_backordered: 'Disponible sur commande',
    av_none: 'Actuellement indisponible'
  };
  const __T_NL = {
    on: 'Levering op', fastest: 'of snelste levering op', free: 'GRATIS',
    uk_free: 'GRATIS levering in het VK', uk_paid: 'Levering in het VK', intl: 'internationale levering bij het afrekenen',
    av_very_low: 'Zeer lage voorraad', av_low: 'Lage voorraad',
    av_normal: 'Op voorraad (bestel nu voor snellere verzending)', av_backordered: 'Op bestelling beschikbaar',
    av_none: 'Momenteel niet beschikbaar'
  };
  const __T_PL = {
    on: 'Dostawa', fastest: 'lub najszybsza dostawa', free: 'GRATIS',
    uk_free: 'DARMOWA dostawa do Wielkiej Brytanii', uk_paid: 'Dostawa do Wielkiej Brytanii', intl: 'dostawa międzynarodowa przy kasie',
    av_very_low: 'Bardzo niski stan magazynowy', av_low: 'Niski stan magazynowy',
    av_normal: 'Dostępne (zamów teraz, aby przyspieszyć wysyłkę)', av_backordered: 'Dostępne na zamówienie',
    av_none: 'Obecnie niedostępne'
  };
  const __T_SV = {
    on: 'Leverans', fastest: 'eller snabbaste leverans', free: 'GRATIS',
    uk_free: 'GRATIS leverans till Storbritannien', uk_paid: 'Leverans till Storbritannien', intl: 'internationell leverans i kassan',
    av_very_low: 'Mycket lågt lagersaldo', av_low: 'Lågt lagersaldo',
    av_normal: 'I lager (beställ nu för snabbare leverans)', av_backordered: 'Tillgänglig att beställa',
    av_none: 'För närvarande inte tillgänglig'
  };
  const __T_EN = {
    on: 'Delivery on', fastest: 'or fastest delivery', free: 'FREE',
    uk_free: 'FREE UK delivery', uk_paid: 'UK delivery', intl: 'international delivery at checkout',
    av_very_low: 'Very low stock', av_low: 'Low stock',
    av_normal: 'In stock (order now for earlier dispatch)', av_backordered: 'Available to order',
    av_none: 'Currently unavailable'
  };
  const T = __lang.startsWith('de') ? __T_DE : (__lang.startsWith('fr') ? __T_FR : (__lang.startsWith('nl') ? __T_NL : (__lang.startsWith('pl') ? __T_PL : (__lang.startsWith('sv') ? __T_SV : __T_EN))));
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy,
          evt.detail.variant.price
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     * @param {?number} variantPrice - current variant price in cents
     */
    updateInventory(count, available, inventoryPolicy, variantPrice = null) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock;
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }

      this.updatePurchaseSummaryAvailability(inventoryLevel, variantPrice);
    }

    updatePurchaseSummaryAvailability(inventoryLevel, variantPrice = null) {
      const productInfo = this.closest('.product-info');
      const availabilityLines = productInfo?.querySelectorAll('.js-purchase-availability-line');
      if (!availabilityLines?.length) return;

      const labels = {
        very_low: T.av_very_low,
        low: T.av_low,
        normal: T.av_normal,
        in_stock: T.av_normal,
        backordered: T.av_backordered,
        none: T.av_none
      };

      const label = labels[inventoryLevel] || T.av_normal;
      const showShipping = inventoryLevel !== 'none' && inventoryLevel !== 'backordered';

      availabilityLines.forEach((availabilityLine) => {
        const summary = availabilityLine.closest('.product-purchase-summary') || productInfo;
        const shippingNote = summary?.querySelector('.js-purchase-shipping-note');
        let deliveryEstimate = summary?.querySelector('.js-purchase-delivery-estimate');
        deliveryEstimate = this.ensurePurchaseDeliveryEstimate(summary, shippingNote, deliveryEstimate);

        const threshold = Number.parseInt(availabilityLine.dataset.freeShippingThreshold || '', 10);
        const price = Number.parseInt(variantPrice, 10);
        const hasPriceThreshold = Number.isFinite(threshold) && Number.isFinite(price);
        const qualifiesForFreeShipping = hasPriceThreshold && price >= threshold;
        const shippingLabel = hasPriceThreshold
          ? (qualifiesForFreeShipping ? availabilityLine.dataset.freeShippingLabel : availabilityLine.dataset.paidShippingLabel)
          : availabilityLine.dataset.shippingLabel;
        const availableNote = hasPriceThreshold
          ? (qualifiesForFreeShipping ? shippingNote?.dataset.freeNote : shippingNote?.dataset.paidNote)
          : shippingNote?.dataset.availableNote;
        if (deliveryEstimate) {
          this.applyPurchaseDeliveryEstimateSettings(deliveryEstimate, this.getPurchaseDeliverySettings(summary));
        }
        const estimateMode = hasPriceThreshold ? (qualifiesForFreeShipping ? 'free' : 'paid') : 'available';
        const availableEstimate = hasPriceThreshold
          ? (this.formatPurchaseDeliveryEstimate(deliveryEstimate, estimateMode)
            || (qualifiesForFreeShipping ? deliveryEstimate?.dataset.freeEstimate : deliveryEstimate?.dataset.paidEstimate))
          : deliveryEstimate?.dataset.availableEstimate;

        availabilityLine.hidden = false;
        availabilityLine.innerText = label;
        if (shippingNote) {
          shippingNote.innerText = showShipping ? availableNote || '' : '';
        }
        if (deliveryEstimate) {
          deliveryEstimate.innerHTML = showShipping ? (this.formatPurchaseDeliveryEstimate(deliveryEstimate, estimateMode) || availableEstimate || '') : '';
        }
      });
    }

    getPurchaseDeliverySettings(context = document) {
      const destination = context?.querySelector?.('.js-purchase-delivery-destination');
      const country = (
        destination?.dataset.country
        || window.Shopify?.country
        || 'GB'
      ).toUpperCase();
      const europeCountryCodes = new Set([
        'AL', 'AD', 'AT', 'BE', 'BA', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI',
        'FR', 'DE', 'GI', 'GR', 'GG', 'HU', 'IS', 'IE', 'IM', 'IT', 'JE', 'LV',
        'LI', 'LT', 'LU', 'MT', 'MC', 'ME', 'NL', 'MK', 'NO', 'PL', 'PT', 'RO',
        'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'GB', 'VA'
      ]);
      const asiaPacificCountryCodes = new Set(['AU', 'NZ', 'JP', 'SG', 'HK', 'KR', 'MY', 'PH', 'TH', 'VN', 'ID', 'TW', 'IN']);

      let shippingLabelFree = T.uk_free;
      let shippingLabelPaid = T.uk_paid;
      let deliveryNoteFree = '';
      let deliveryNotePaid = '';
      let estimatePrefix = T.uk_free;
      let estimateMinDays = 1;
      let estimateMaxDays = 3;
      let estimateSuffix = '';
      let estimateSingleDate = true;
      let fastestPrefix = T.fastest;
      let fastestDays = 1;

      if (country !== 'GB') {
        shippingLabelFree = T.intl;
        shippingLabelPaid = T.intl;
        deliveryNoteFree = '';
        deliveryNotePaid = '';
        estimatePrefix = T.on;
        estimateMinDays = 7;
        estimateMaxDays = 15;
        estimateSuffix = '';
        estimateSingleDate = true;
        fastestPrefix = T.fastest;
        fastestDays = 7;

        if (country === 'IE') {
          estimatePrefix = T.on;
          estimateMinDays = 2;
          estimateMaxDays = 4;
          fastestDays = 2;
        } else if (country === 'US') {
          estimatePrefix = T.on;
          estimateMinDays = 5;
          estimateMaxDays = 10;
          fastestDays = 5;
        } else if (europeCountryCodes.has(country)) {
          estimatePrefix = T.on;
          estimateMinDays = 3;
          estimateMaxDays = 7;
          fastestDays = 3;
        } else if (asiaPacificCountryCodes.has(country)) {
          estimatePrefix = T.on;
          estimateMinDays = 12;
          estimateMaxDays = 20;
          fastestDays = 12;
        }
      }

      return {
        shippingLabelFree,
        shippingLabelPaid,
        deliveryNoteFree,
        deliveryNotePaid,
        estimatePrefix,
        estimateMinDays,
        estimateMaxDays,
        estimateSuffix,
        estimateSingleDate,
        fastestPrefix,
        fastestDays
      };
    }

    ensurePurchaseDeliveryEstimate(productInfo, shippingNote, deliveryEstimate) {
      if (deliveryEstimate || !productInfo || !shippingNote) return deliveryEstimate;

      const settings = this.getPurchaseDeliverySettings();
      const availabilityLine = productInfo.querySelector('.js-purchase-availability-line');
      if (availabilityLine) {
        availabilityLine.dataset.freeShippingThreshold = availabilityLine.dataset.freeShippingThreshold || '3000';
        availabilityLine.dataset.freeShippingLabel = availabilityLine.dataset.freeShippingLabel || settings.shippingLabelFree;
        availabilityLine.dataset.paidShippingLabel = availabilityLine.dataset.paidShippingLabel || settings.shippingLabelPaid;
        availabilityLine.dataset.shippingLabel = availabilityLine.dataset.shippingLabel || settings.shippingLabelPaid;
      }

      shippingNote.dataset.freeNote = shippingNote.dataset.freeNote || settings.deliveryNoteFree;
      shippingNote.dataset.paidNote = shippingNote.dataset.paidNote || settings.deliveryNotePaid;
      shippingNote.dataset.availableNote = shippingNote.dataset.availableNote || settings.deliveryNotePaid;

      const estimate = document.createElement('span');
      estimate.className = 'product-purchase-summary__estimate js-purchase-delivery-estimate';
      this.applyPurchaseDeliveryEstimateSettings(estimate, settings);
      shippingNote.insertAdjacentElement('afterend', estimate);

      return estimate;
    }

    applyPurchaseDeliveryEstimateSettings(deliveryEstimate, settings) {
      if (!deliveryEstimate || !settings) return;

      const estimateText = this.formatPurchaseDeliveryEstimateFromSettings(settings);
      ['free', 'paid', 'available'].forEach((mode) => {
        const prefixKey = `${mode}EstimatePrefix`;
        const minKey = `${mode}EstimateMinDays`;
        const maxKey = `${mode}EstimateMaxDays`;
        const suffixKey = `${mode}EstimateSuffix`;
        const singleDateKey = `${mode}EstimateSingleDate`;
        const fastestPrefixKey = `${mode}FastestPrefix`;
        const fastestDaysKey = `${mode}FastestDays`;
        const textKey = `${mode}Estimate`;

        deliveryEstimate.dataset[prefixKey] = deliveryEstimate.dataset[prefixKey] || settings.estimatePrefix;
        deliveryEstimate.dataset[minKey] = deliveryEstimate.dataset[minKey] || String(settings.estimateMinDays);
        deliveryEstimate.dataset[maxKey] = deliveryEstimate.dataset[maxKey] || String(settings.estimateMaxDays);
        deliveryEstimate.dataset[suffixKey] = deliveryEstimate.dataset[suffixKey] || settings.estimateSuffix;
        deliveryEstimate.dataset[singleDateKey] = deliveryEstimate.dataset[singleDateKey] || String(Boolean(settings.estimateSingleDate));
        deliveryEstimate.dataset[fastestPrefixKey] = deliveryEstimate.dataset[fastestPrefixKey] || settings.fastestPrefix || '';
        deliveryEstimate.dataset[fastestDaysKey] = deliveryEstimate.dataset[fastestDaysKey] || String(settings.fastestDays || 0);
        deliveryEstimate.dataset[textKey] = deliveryEstimate.dataset[textKey] || estimateText;
      });
    }

    formatPurchaseDeliveryEstimateFromSettings(settings) {
      return this.formatDeliveryEstimateText(
        settings.estimatePrefix,
        settings.estimateMinDays,
        settings.estimateMaxDays,
        settings.estimateSuffix,
        settings.estimateSingleDate,
        settings.fastestPrefix,
        settings.fastestDays
      );
    }

    formatPurchaseDeliveryEstimate(deliveryEstimate, mode = 'available') {
      if (!deliveryEstimate) return '';

      const prefix = deliveryEstimate.dataset[`${mode}EstimatePrefix`] || deliveryEstimate.dataset.availableEstimatePrefix;
      const minDays = Number.parseInt(deliveryEstimate.dataset[`${mode}EstimateMinDays`] || deliveryEstimate.dataset.availableEstimateMinDays || '', 10);
      const maxDays = Number.parseInt(deliveryEstimate.dataset[`${mode}EstimateMaxDays`] || deliveryEstimate.dataset.availableEstimateMaxDays || '', 10);
      const suffix = deliveryEstimate.dataset[`${mode}EstimateSuffix`] || deliveryEstimate.dataset.availableEstimateSuffix || '';
      const singleDate = (deliveryEstimate.dataset[`${mode}EstimateSingleDate`] || deliveryEstimate.dataset.availableEstimateSingleDate) === 'true';
      const fastestPrefix = deliveryEstimate.dataset[`${mode}FastestPrefix`] || deliveryEstimate.dataset.availableFastestPrefix || '';
      const fastestDays = Number.parseInt(deliveryEstimate.dataset[`${mode}FastestDays`] || deliveryEstimate.dataset.availableFastestDays || '', 10);

      if (!prefix || !Number.isFinite(minDays) || !Number.isFinite(maxDays)) return '';
      const isFree = mode === 'free' || (mode === 'available' && deliveryEstimate.dataset.availableFree === 'true');
      return this.formatDeliveryEstimateText(prefix, minDays, maxDays, suffix, singleDate, fastestPrefix, fastestDays, isFree);
    }

    formatDeliveryEstimateText(prefix, minDays, maxDays, suffix = '', singleDate = false, fastestPrefix = '', fastestDays = Number.NaN, isFree = false) {
      const dateRange = this.formatDeliveryDateRange(minDays, maxDays, singleDate);
      const suffixText = suffix ? ` ${this.escapeHtml(suffix)}` : '';
      const detailsLink = '<a class="product-purchase-summary__details" href="/pages/delivery-info">Details</a>';
      const freeText = isFree ? `<strong class="product-purchase-summary__free">${T.free}</strong> ` : '';
      const fastestText = fastestPrefix && Number.isFinite(fastestDays) && fastestDays > 0
        ? `<br> ${this.escapeHtml(fastestPrefix)} <strong class="product-purchase-summary__date">${this.escapeHtml(this.formatDeliveryDateRange(fastestDays, fastestDays, true))}</strong> ${detailsLink}`
        : '';
      return `${freeText}${this.escapeHtml(prefix)} <strong class="product-purchase-summary__date">${this.escapeHtml(dateRange)}</strong>${suffixText} ${detailsLink}${fastestText}`;
    }

    escapeHtml(value) {
      const replacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      return String(value ?? '').replace(/[&<>"']/g, (char) => replacements[char]);
    }

    formatDeliveryDateRange(minDays, maxDays, singleDate = false) {
      return window.UKBKDeliveryDates?.formatDeliveryDateRange?.(minDays, maxDays, { singleDate }) || '';
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
